<template>
    <div id="app" class="h-100">
        <div v-if="maintenance" class="align-self-center text-center" style="margin-top: 10%">
            <img class="mb-4" src="//cdn.studiesweekly.com/logo/2017+SW_horiz-black.png" alt="" width="auto" height="45">

            <section class="py-4 bg-light">
                <div class="container text-center">
                    <div class="mx-auto" style="max-width: 640px; line-height: 1.6">
                        <h3 class="mb-3">Under Maintenance</h3>
                        <p>The Studies Weekly Online Store is temporarily shut down, per a worldwide alert “of critical vulnerabilities in a widely used programming language” used in most website structures.</p>
                        <p>As a precaution, we have temporarily taken the Store offline while our engineering team applies the security update. We are making this choice on purpose. We would rather pause access briefly than take any risk with your data or information.</p>
                        <p>Once a patch for this vulnerability is available, and our technology team has determined the website is fully secure, the Store will be restored to full function.</p>
                        <p class="mb-0">
                            More information here:
                            <a href="https://www.reuters.com/world/asia-pacific/eu-agency-warns-websites-may-need-be-taken-offline-php-prepares-patches-2026-10-21/" target="_blank" rel="noopener noreferrer">Reuters</a>
                        </p>
                    </div>
                </div>
            </section>
        </div>
        <div v-else-if="$auth.ready()" class="h-100">
            <router-view />
        </div>
        <div v-else class="h-100 d-flex">
            <div class="align-self-center mx-auto">
                <font-awesome-icon :icon="['fad', 'circle-notch']" size="3x" spin />
            </div>
        </div>
    </div>
</template>

<style lang="scss">

</style>

<script>

import {mapGetters, mapState} from "vuex";

export default {
    components: {},
    data: () => ({
        maintenance: false,
    }),
    computed: mapGetters({
        isHomeschoolStore: 'isHomeschoolStore',
    }),
    created() {
        this.setDefaultSchoolYear();
    },
    watch: {
        isHomeschoolStore(isHomeschool) {

            // If first time enabling homeschool, show message modal.
            // Built here for now since BvModal is required to be in a vue component.
            if (isHomeschool && localStorage.getItem("first_homeschool_visit") === null)
            {
                this.$bvModal.msgBoxOk('We’ve simplified our homeschool product options to make choosing the right resources easier. Please take a moment to review the available options before placing your order.', {
                    title: 'We’ve updated our homeschool offerings',
                    size: 'lg'
                });
                localStorage.setItem("first_homeschool_visit", true);
            }
        }
    },
    methods: {
        setDefaultSchoolYear() {
            // if (this.$store.getters.getCurrentSchoolYear !== null)
            //     return;

            let schoolYear = this.$store.getters.getActiveSchoolYear;

            console.log('Setting default school year', schoolYear);
            this.$store.commit('setSchoolYear', schoolYear);
        }
    }
}
</script>
